import React, { Fragment, useEffect, useState } from "react";
// import * as Yup from 'yup';
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import { Link , useNavigate } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import LogoImg from '../../assets/images/hroselylogo.jpg'
// import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorMessage } from '@hookform/error-message';
import { useDispatch, useSelector } from 'react-redux';
import LogoBlack from '../../assets/images/main-logo-black.svg';
// import { VALIDATION_MESSAGE } from "../../Constants/Constants";
import { decodeID, encodeID, getItemFromStorage, isJson, removeItemFromStorage, setItemToStorage } from "../../utils/Helper";
import { AdminLogInAction } from "../../Redux/Action/AuthAction";
import { APP_DEVELOPED_BY, APP_NAME, BASE_URL, url } from "../../Config/Config";
import ToastDefault from "../FieldComponets/Toast";
import { StorageConstant } from "../../Constants/Constants";
import { FormattedMessage, useIntl } from "react-intl";
import LanguageSwitcher from "../Layouts/LanguageSwitcher";
// const LogoImg = require('../../assets/images/hroselylogo.jpg')
const LogoImgs = require('../../assets/images/loginLogo.jpg')
const Logo  = require("../../assets/images/newLogo.png")

interface FormInputs {
    email: string,
    password: string,
    remember_me: boolean
}
function Login() {

    const dispatch = useDispatch<any>();
    const navigate = useNavigate();
    const intl = useIntl();
    const log_in = useSelector((state: any) => state.AdminLogInState)
    const { register, formState: { errors }, handleSubmit, watch, setValue } = useForm<FormInputs>({
        // resolver: yupResolver(formSchema),
    });
    const [passwordType, setPasswordType] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const onSubmit = (data: FormInputs) => {
        dispatch(AdminLogInAction(data))
    };
    
    useEffect(() => {
        setIsLoading(true)
        const getInfo: any = getItemFromStorage(StorageConstant?.session_info);
        const decodedCookie: any = decodeID(getInfo);
        if (decodedCookie && isJson(decodedCookie)) {
            const isUserSession: any = JSON.parse(decodedCookie)
            setValue("email", isUserSession?.email)
            setValue("password", isUserSession?.password)
            setValue("remember_me", true)
        }
        setIsLoading(false)
    }, [isLoading])


    useEffect(() => {
        if (log_in?.status === true) {
            if (watch('remember_me') === true) {
                const data = {
                    email: watch('email'),
                    password: watch('password')
                }
                const jsonData = JSON.stringify(data);
                setItemToStorage(StorageConstant?.session_info, encodeID(jsonData))
            } else {
                removeItemFromStorage(StorageConstant?.session_info)
            }
        //   return  console.log( log_in,"deepak-=-----=====================>>>>")
            setItemToStorage(StorageConstant?.is_admin_login_token, log_in?.data?.access_token);
            setItemToStorage(StorageConstant?.is_admin_login_token, log_in?.data?.access_token);

            setItemToStorage(StorageConstant?.is_admin_timezone, log_in?.data?.admin_timezone);


            setTimeout(function () {
                window.location.href = BASE_URL + '/dashboard'
                // navigate(`${url}/dashboard`)
            }, 800)
        }
        if (getItemFromStorage(StorageConstant?.is_admin_login_token) !== null) {
            window.location.href = BASE_URL + '/dashboard'
            // navigate(`${url}/dashboard`)

        }

    }, [log_in]);

    return (
        <Fragment>
            {log_in?.loading ? <Spinner /> : ""}
            <div className="auth-body-bg">
                <div className=" container-fluid p-0">
                    <div className="row g-0">
                        <div className="col-xl-3">
                            <div className="auth-full-page-content p-md-4">
                                <div className="w-100">
                                    <div className="d-flex flex-column h-100">
                                        <div className="mb-4 mb-md-5 d-flex justify-content-between align-items-center">
                                            <Link to="/" style={{width: '170px'}} className="d-flex justify-content-center auth-logo">
                                                <img className="w-100" src={Logo} alt="image" />
                                            </Link>
                                            <LanguageSwitcher />
                                        </div>
                                        <div className="my-auto">
                                            <div>
                                                <h5 style={{color: '#e17665'}}><FormattedMessage id="welcome_back" /></h5>
                                                <p className="text-muted">
                                                    <FormattedMessage
                                                        id="sign_in_continue"
                                                        values={{ appName: APP_NAME }}
                                                    />
                                                </p>
                                            </div>
                                            <div className="mt-4">
                                                <form onSubmit={handleSubmit(onSubmit)}>
                                                    <div className="mb-3">
                                                        <label htmlFor="username" className="form-label"><FormattedMessage id="email" /></label>
                                                        <input type="email" className="form-control" id="username" placeholder={intl.formatMessage({ id: "enter_email" })} {...register("email", {
                                                            required: intl.formatMessage({ id: "please_enter_email" }),
                                                            pattern: {
                                                                value: /^\S+@\S+$/i,
                                                                message: intl.formatMessage({ id: "enter_valid_email" })
                                                            }


                                                        })}
                                                            onInput={(e: any) => {
                                                                e.target.value = e.target.value.replace(/\s/g, '');
                                                            }}
                                                        />
                                                        <ErrorMessage
                                                            errors={errors}
                                                            name="email"
                                                            render={({ message }) => <p style={{ color: 'red' }}>{message}</p>}
                                                        />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label className="form-label"><FormattedMessage id="password" /></label>
                                                        <div className="input-group auth-pass-inputgroup">
                                                            <input
                                                                type={passwordType ? "text" : "password"} className="form-control m-0" placeholder={intl.formatMessage({ id: "enter_password" })} aria-label="Password" aria-describedby="password-addon" {...register("password", { required: intl.formatMessage({ id: "please_enter_password" }) })} />

                                                            <button className="btn btn-light " type="button" onClick={() => { setPasswordType(!passwordType); }} ><i className={`${passwordType ? "mdi mdi-eye-outline" : "mdi mdi-eye-off-outline"}`}  ></i></button>
                                                        </div>
                                                        <ErrorMessage
                                                            errors={errors}
                                                            name="password"
                                                            render={({ message }) => <p style={{ color: 'red' }}>{message}</p>}
                                                        />
                                                    </div>
                                                    <input id="remeber" type="checkbox" {...register("remember_me")} />
                                                    <label htmlFor="remeber" className="ms-1"><FormattedMessage id="remember_me" /></label>
                                                    <div className="mt-3 d-grid">
                                                        <button type="submit" className="btn theme-bg text-white waves-effect waves-light"><FormattedMessage id="log_in" /></button>
                                                    </div>
                                                    {/* className="text-muted" */}
                                                    <div className="mt-4 text-center" style={{ color: 'red' }}>
                                                        <Link to={url + '/forgot-password'} className="theme-color"><i className="mdi mdi-lock me-1" ></i> <FormattedMessage id="forgot_password" /></Link>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div className="mt-4 mt-md-4 text-center">
                                            <p>© <script>document.write(new Date().getFullYear())</script> {APP_NAME}. Crafted by {APP_DEVELOPED_BY}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-9 horselylogo">
                            <img  src={LogoImgs} alt="image" />

                        </div>
                    </div>
                </div>
            </div>
            <ToastDefault />
        </Fragment>
    );
}

export default Login;